'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('customLoader', function($q, $http) {
  return function(options) {
    let deferred = $q.defer();
    let mainLang = $http.get('resources/lang/' + options.key + '.json');

    $q.all([mainLang]).then(function(response) {
      deferred.resolve($.extend(true, response[0].data, {}));
    });
    return deferred.promise;
  };
});

MemberApp.config(function($translateProvider, tmhDynamicLocaleProvider, localStorageEnabled, featureTogglesProvider,
  toggleConfig) {

  var $cookies;
  angular.injector(['ngCookies']).invoke(['$cookies', function(_$cookies_) {
    $cookies = _$cookies_;
  }]);

  featureTogglesProvider.setFeatures(toggleConfig.toggles);

  var locale = $cookies.get('language') || navigator.language;

  if (locale !== 'en' && locale !== 'fr') {
    locale = 'en';
  }

  $translateProvider.useLoader('customLoader');
  // Allow message format for interpolating in values.
  $translateProvider.addInterpolation('$translateMessageFormatInterpolation');
  // Tell the module what language to use by default
  $translateProvider.preferredLanguage(locale);
  // Squashes warning - will be deprecated in Angular Translate v3
  $translateProvider.useSanitizeValueStrategy(null);

  tmhDynamicLocaleProvider.defaultLocale(locale + '-ca');

});

MemberApp.config(function(tmhDynamicLocaleProvider, otppConstants) {
  tmhDynamicLocaleProvider.localeLocationPattern(otppConstants.localeFiles + 'angular-locale_{{locale}}.js');
});

MemberApp.config(function($cookiesProvider) {
  $cookiesProvider.defaults.path = '/';
});

MemberApp.config(function($httpProvider, otppConstants) {
  $httpProvider.defaults.headers.common['Content-Type'] = 'application/json';
  $httpProvider.defaults.headers.common['Accept'] = 'application/json';
  $httpProvider.interceptors.push(function($cookies) {
    return {
      response: function(response) {
        if (response.config.url.indexOf(otppConstants.apiUrl) >= 0 && response.status >= 200 && response.status < 300 &&
          $cookies.get(otppConstants.mbrAuthKey)) {
          var THIRTY_MINUTES_IN_MS = 1000 * 60 * 30;
          var datePlusThirty = new Date(Date.now() + THIRTY_MINUTES_IN_MS);
          $cookies.put(otppConstants.mbrAuthKey, $cookies.get(otppConstants.mbrAuthKey), {path: '/',
            expires: datePlusThirty, samesite: 'none', Secure: ''});
        }
        return response;
      }
    };
  });
});

/*eslint max-params: [1, 15] */
MemberApp.config(function(dispatcherProvider, PensionModulesStoreProvider,
  PsobAlertStoreProvider, DocumentStoreProvider, userStoreProvider,
  PensionSummaryStoreProvider) {
  dispatcherProvider.register(PensionModulesStoreProvider.getListeners());
  dispatcherProvider.register(PsobAlertStoreProvider.getListeners());
  dispatcherProvider.register(userStoreProvider.getListeners());
  dispatcherProvider.register(DocumentStoreProvider.getListeners());
  dispatcherProvider.register(PensionSummaryStoreProvider.getListeners());
});

MemberApp.config(['$compileProvider', function($compileProvider) {
  $compileProvider.debugInfoEnabled(false);
}]);

